import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import SceneView from './views/SceneView';
import logo from './images/gmw_qf_rgb_negativ.png'
import LoadingScreen from './components/LoadingScreen';
import Infobox from './components/Infobox';
import ResetButton from './components/ResetButton';

const root = ReactDOM.createRoot(
  document.getElementById('react-app') as HTMLElement
);


root.render(
  <React.StrictMode>
    <img className='logo' src={logo} alt='logo' />
    <SceneView />
    <ResetButton />
    <Infobox />
    <LoadingScreen />
  </React.StrictMode>
);
